import React from 'react'
// import PropTypes from 'prop-types'
import detailStyles from '../../styles/tracker-modules/ratesDetail.module.less'
import ProgressBar from './progressBar'

function RateDetail({
  style,
  className,
  areaName,
  areaRegion,
  population,
  numAdmin,
  numDistrib,
  firstDose,
  firstDoseCoverage,
  adminPer100k,
  mapState,
  pctFullyVaccinated,
  numFullyVaccinated,
  pctPartiallyVaccinated,
  numPartiallyVaccinated,
}) {
  return (
    <div className={className}>
      {style === 'partial' && (
        <>
          <p className={detailStyles.subhed} id="bar-label-pv">
            In{' '}
            <strong>
              {areaName === mapState ? areaName : `${areaName} County`}
            </strong>
            ,{' '}
            <strong>
              {numPartiallyVaccinated.toLocaleString()}{' '}
              {numPartiallyVaccinated === 1 ? 'person' : 'people'}
            </strong>{' '}
            {numPartiallyVaccinated === 1 ? 'has' : 'have'}
            {' been '}
            <span data-label="pv">partially&nbsp;vaccinated</span>. That's{' '}
            <strong>{pctPartiallyVaccinated.toFixed(2)}%</strong>
            of the estimated population.
          </p>

          <ProgressBar
            data={[{ barStyle: 'pv', val: pctPartiallyVaccinated / 100 }]}
            total={population}
            label="people"
            labeledById="bar-label-pv"
          />

          <p className={detailStyles.subhed} id="bar-label-pvf">
            <strong>
              {numFullyVaccinated.toLocaleString('en-US')}{' '}
              {numFullyVaccinated === 1 ? 'person' : 'people'}
            </strong>{' '}
            {numFullyVaccinated === 1 ? 'has been ' : 'have been '}
            <span data-label="pvf">fully&nbsp;vaccinated</span>.&nbsp; That's{' '}
            <strong>{pctFullyVaccinated.toFixed(2)}%</strong>
            of the estimated population.
          </p>

          <ProgressBar
            total={population}
            data={[{ barStyle: 'pvf', val: pctFullyVaccinated / 100 }]}
            barStyle={'pvf'}
            label="people"
            labeledById="bar-label-pvf"
          />
        </>
      )}

      {style === 'per100k' && (
        <>
          <p className={detailStyles.subhed} id="bar-label-100k">
            In <strong>{areaName} County</strong>
            {', '}
            <strong>
              {numAdmin.toLocaleString()} total{' '}
              {numAdmin === 1 ? 'dose' : 'doses'}
            </strong>{' '}
            {numAdmin === 1 ? 'has' : 'have'}
            {' been '}
            administered. That means about{' '}
            <strong>{Math.round(adminPer100k).toLocaleString()} </strong>
            doses (including first and second doses) have been &nbsp;
            <span data-label="pv">administered</span>&nbsp;for every 100,000
            people.
          </p>

          {/* removing for now */}
          {/* <ProgressBar
            data={[{ barStyle: 'pv', val: adminPer100k / 100000 }]}
            total={100000}
            label="people"
            labeledById="bar-label-100k"
            showLabels={false}
          /> */}
        </>
      )}

      {style === 'per100k2' && (
        <>
          <p className={detailStyles.subhed} id="bar-label-100k">
            {areaName === mapState ? (
              <>
                In <strong>{areaName}</strong>,{' '}
              </>
            ) : (
              <>
                <strong>
                  {areaName === mapState ? areaName : `${areaName} County`}
                </strong>{' '}
                is in the <span data-label="region">{areaRegion}</span> , where{' '}
              </>
            )}
            <strong>
              {(numPartiallyVaccinated + numFullyVaccinated).toLocaleString()}
            </strong>{' '}
            people {numPartiallyVaccinated === 1 ? 'has' : 'have'} received at
            least one dose of the vaccine, and{' '}
            <strong>{numFullyVaccinated.toLocaleString()}</strong> people have
            received all shots. That means about{' '}
            <strong>
              {(pctFullyVaccinated + pctPartiallyVaccinated).toFixed(2)}%{' '}
            </strong>
            of the <span data-label="region">{areaRegion}'s</span> population
            has received at least one dose of a vaccine against COVID-19.
          </p>

          <ProgressBar
            total={population}
            data={[
              {
                barStyle: 'pvf',
                val: (pctFullyVaccinated + pctPartiallyVaccinated) / 100,
              },
            ]}
            barStyle={'pvf'}
            label="people"
            labeledById="bar-label-pvf"
            showText={true}
          />
        </>
      )}

      {style === 'connecticut' && (
        <>
          <p className={detailStyles.subhed} id="bar-label-100k">
            {areaName === mapState ? (
              <>
                In <strong>{areaName}</strong>,{' '}
              </>
            ) : (
              <>
                In{' '}
                <strong>
                  {areaName === mapState ? areaName : `${areaName}`},{' '}
                  {parseInt(numFullyVaccinated).toLocaleString()} people
                </strong>{' '}
                have been &nbsp;
                <span data-label="pv">fully vaccinated</span>. That means about{' '}
                <strong>{pctFullyVaccinated.toFixed(2)}%</strong> of{' '}
                <strong>{areaName}'s</strong> population has been fully
                vaccinated.
              </>
            )}
          </p>

          <ProgressBar
            total={100}
            data={[
              {
                barStyle: 'pv',
                val: pctFullyVaccinated / 100,
              },
            ]}
            label="%"
            labeledById="bar-label-100k"
            showLabels={false}
          />
        </>
      )}

      {style === 'illinois' && (
        <>
          <p className={detailStyles.subhed} id="bar-label-100k">
            {areaName === mapState ? (
              <>
                In <strong>{areaName}</strong>,{' '}
              </>
            ) : (
              <>
                In{' '}
                <strong>
                  {areaName} County, {numFullyVaccinated.toLocaleString()}{' '}
                  people
                </strong>{' '}
                have been fully vaccinated. That means about{' '}
                <strong>{pctFullyVaccinated.toFixed(2)}%</strong> of{' '}
                <strong>{areaName} County's</strong> population has been fully
                vaccinated.
              </>
            )}
          </p>

          <ProgressBar
            total={100}
            data={[
              {
                barStyle: 'pv',
                val: pctFullyVaccinated / 100,
              },
            ]}
            label="%"
            labeledById="bar-label-100k"
            showLabels={false}
          />
        </>
      )}

      {style === 'michigan' && (
        <>
          <p className={detailStyles.subhed} id="bar-label-100k">
            {areaName === mapState ? (
              <>
                In <strong>{areaName}</strong>,{' '}
              </>
            ) : (
              <>
                In{' '}
                <strong>
                  {areaName} County, {numFullyVaccinated.toLocaleString()}{' '}
                  people
                </strong>{' '}
                have been fully vaccinated. That means about{' '}
                <strong>{pctFullyVaccinated.toFixed(2)}%</strong> of{' '}
                <strong>{areaName} County's</strong> population has been fully
                vaccinated.
              </>
            )}
          </p>

          <ProgressBar
            total={100}
            data={[
              {
                barStyle: 'pv',
                val: pctFullyVaccinated / 100,
              },
            ]}
            label="%"
            labeledById="bar-label-100k"
            showLabels={false}
          />
        </>
      )}
    </div>
  )
}

// RateDetail.propTypes = {}

export default RateDetail
